import React, { useEffect, useState } from "react";
import styles from "../../css/SmsDownloadReport.module.css";
import { Box } from "@mui/material";
import HighlightOffIcon from "@mui/icons-material/HighlightOff";
import Loader from "../Loader/Loader";
import MasterTable from "../common/MasterTable";

const DownloadReport = ({
  handleCloseReportDown,
  callApi,
  data,
  pageDowRepDetails,
  noData,
  loading,
}) => {
  const [currentPage, setCurrentPage] = useState(1);

  const SMSDownloadHeaders = [
    "Request ID",
    "Req Date & Time",
    "From Date",
    "To Date",
    "Status",
    "File",
  ];

  const SMSDownloadHeaderToKeyMap = {
    "Request ID": "id",
    "Req Date & Time": "createdDate",
    "From Date": "reqFromDate",
    "To Date": "reqToDate",
    Status: "status",
    File: "downloadUrl",
  };

  useEffect(() => {
    callApi(1);
  }, []);

  const pageSizeCount = pageDowRepDetails?.pageSize || 0;
  const totalRecord = pageDowRepDetails?.totalRecords || 0;

  return (
    <Box component="form">
      <div className={styles.modalOverlay}>
        <div className={styles.modalBox}>
          {/* Header */}
          <div className={styles.modalHeader}>
            <h2 className={styles.modalTitle}>Download Report</h2>
            <button
              onClick={handleCloseReportDown}
              className={styles.closeButton}
            >
              <HighlightOffIcon />
            </button>
          </div>

          {/* Content */}
          <div className={styles.DownModalContent}>
            {loading ? (
              <Loader />
            ) : (
              <MasterTable
                headers={SMSDownloadHeaders}
                data={data}
                filterFields={["id"]}
                entityType="SMS Download Report"
                headerToKeyMap={SMSDownloadHeaderToKeyMap}
                loading={loading}
                pageDetails={pageDowRepDetails}
                noData={noData}
                currentPage={currentPage}
                pageSize={pageSizeCount}
                totalRecord={totalRecord}
                fetchNextData={(page) => callApi(page)}
                setCurrentPage={setCurrentPage}
                hideAction="hideAction"
              />
            )}
          </div>
        </div>
      </div>
    </Box>
  );
};

export default DownloadReport;
